import Spin from 'components/spin'

export default function LazyRender({ done = false, render }) {
  return done ? render() : <Spin />
}
